import Dialog from '../../ui/modal/Dialog';
import React from 'react';
import {handleError, handleSuccess} from '../../utils/Apollo';
import {useMutation} from '@apollo/client';
import gql from 'graphql-tag';
import OldUrls from '../../models/utils/OldUrls';

type Props = {
  id: string
  eventId: string
  name: string
  show: boolean
  setShowDialog: (close: boolean) => void
}

export default function DeleteAttendeeDlg({id, eventId, name, show, setShowDialog}: Props) {
  const [deleteAttendee] = useMutation(deleteMutation);

  const onConfirmRemoval = () => {
    deleteAttendee({
      variables: {id},
    }).then(() => {
      handleSuccess(`Attendee deleted`);
      setShowDialog(false);
      setTimeout(() => {
        window.location.replace(OldUrls.event(eventId));
      }, 1000);
    }, (apolloError) => handleError(apolloError));
  };

  return (
    <Dialog show={show} actionBtnTitle="Delete" onClose={() => setShowDialog(false)}
      title={`Delete attendee`} onConfirm={() => onConfirmRemoval()} closeBtnTitle="Cancel">
      <p>
        You are going to delete <b>{name}</b> attendee from the system. This action cannot be undone.
      </p>
    </Dialog>
  )
}

const deleteMutation = gql`
  mutation DeleteMutation($id: ID!)
  {
    attendee: deleteAttendee(attendeeId: $id) {
      id
    }
  }
`;
